{
  "title": "Registre SOR",
  "subtitle": "Gestion des Crédits Carbone",
  "memberSubtitle": "Tableau de Bord du Développeur de Projet",
  "welcome": "Bienvenue",
  "login": "Connexion",
  "logout": "Déconnexion"
}